import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cartLocalStorageService } from "../services/CartLocalStorageService";
import { makeAjaxCall } from "../utils";

export const getCart = createAsyncThunk(
  "cart/getCart",
  async (cartId, thunkApi) => {
    let cartUrl = $("#API_CART_URL").val();
    if (cartId) {
      cartUrl += `?id=${cartId}`;
    }
    return await makeAjaxCall({
      url: cartUrl,
    });
  }
);

export const cartSlice = createSlice({
  name: "cart",
  initialState: cartLocalStorageService.getCart(),
  reducers: {
    addCartItem: (state, action) => {
      const newItems = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      state.push(...newItems);
      return state;
    },
    deleteCartItem: (state, action) => {
      return state.filter((item) => item.id !== action.payload);
    },
    editCartItem: (state, action) => {
      const itemsToUpdate = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      itemsToUpdate.forEach((el) => {
        const cartItemIndex = state.findIndex(
          (item) => item.id === el.id
        );
        if (cartItemIndex !== -1) {
          const { item: itemUpd, ...updData } = el;
          state[cartItemIndex] = {
            ...state[cartItemIndex],
            ...updData,
            item: {
              ...state[cartItemIndex].item,
              ...itemUpd,
            },
          };
        }
      });

      return state;
    },
    quantityChange: (state, action) => {
      const itemIndex = state.findIndex(
        (item) => item.id === action.payload.cartItemId
      );
      if (itemIndex !== -1) {
        state[itemIndex].qty = action.payload.qty;
      }
      return state;
    },
    clearCart: (state) => {
      return [];
    },
    setCart: (state, action) => {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCart.fulfilled, (state, action) => {
      return action.payload.lines;
    });
  },
});

export const {
  addCartItem,
  deleteCartItem,
  editCartItem,
  quantityChange,
  clearCart,
  setCart,
} = cartSlice.actions;
